import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import styles from '../../../assets/jss/pages/adminSettingCustomTimerCTRLStyle';
import Snackbar from '../../../components/Snackbar/Snackbar';
import GridContainer from '../../../components/Grid/GridContainer';
import WrapperContainer from '../../../components/Container/WrapperContainer';
import Typography from '../../../components/Typography/CustomTypography';
import CleanableInput from '../../../components/Input/CleanableInput';
import Button from '../../../components/Button/CustomButton';
import AlertDialog from '../../../components/Dialog/AlertDialog';
import GridItem from '../../../components/Grid/GridItem';
import Validation from '../../../common/Validation';

const useStyles = makeStyles(styles);

const SettingCustomTimerCTRL = ({
    getSettingCustomTimerctrl,
    clearGetSettingCustomTimerctrl,
    updateSettingCustomTimerctrl,
    clearUpdateSettingCustomTimerctrl,
    customTimerctrl,
    updateCustomTimerctrl,
    updateStatusTimerctrl,
    eventInfo,
}) => {
    const classes = useStyles();
    const { shortName } = useParams();
    const intl = useIntl();
    const [params, setParams] = useState({});
    const [validateResults, setValidateResults] = useState({});
    const [isOpenSnackbar, setIsOpenSnackbar] = useState({ isOpen: false, message: '' });
    const [isOpenConfirmSuccess, setIsOpenConfirmSuccess] = useState({ open: false, content: '', type: '' });

    useEffect(() => {
        getSettingCustomTimerctrl({
            eventShortName: shortName,
        });
        return () => {
            clearGetSettingCustomTimerctrl();
            clearUpdateSettingCustomTimerctrl();
        };
    }, []);

    useEffect(() => {
        if (!_.isEmpty(customTimerctrl)) {
            setParams({
                TC_exhlist_before: customTimerctrl?.TC_exhlist_before || '',
                TC_exhprod_after : customTimerctrl?.TC_exhprod_after || '',
                TC_smn_before    : customTimerctrl?.TC_smn_before || '',
                TC_smn_after     : customTimerctrl?.TC_smn_after || '',
                TC_live_before   : customTimerctrl?.TC_live_before || '',
                TC_live_after    : customTimerctrl?.TC_live_after || '',
                TC_smnord_before : customTimerctrl?.TC_smnord_before || '',
                TC_smnord_after  : customTimerctrl?.TC_smnord_after || '',


            });
        }
    }, [customTimerctrl]);

    useEffect(() => {
        if (updateStatusTimerctrl) {
            setIsOpenSnackbar({ isOpen: true, message: '更新しました。' });
            getSettingCustomTimerctrl({
                eventShortName: shortName,
            });
            clearUpdateSettingCustomTimerctrl();
        }
    }, [updateStatusTimerctrl]);

    const handleChange = (title, value) => {
        setParams((prev) => ({ ...prev, [title]: value }));
    };

    const validate = () => {
        const validateRules = {
            TC_exhlist_before: [
            		() => params.TC_exhlist_before && Validation.isInt(params.TC_exhlist_before ),
            	],
            TC_exhprod_after: [
            		() => params.TC_exhprod_after && Validation.isInt(params.TC_exhprod_after ),
            	],
            TC_smn_before: [
            		() => params.TC_smn_before && Validation.isInt(params.TC_smn_before ),
            	],
            TC_smn_after: [
            		() => params.TC_smn_after && Validation.isInt(params.TC_smn_after ),
            	],
            TC_live_before: [
            		() => params.TC_live_before && Validation.isInt(params.TC_live_before ),
            	],
            TC_live_after: [
            		() => params.TC_live_after && Validation.isInt(params.TC_live_after ),
            	],
            TC_smnord_before: [
            		() => params.TC_smnord_before && Validation.isInt(params.TC_smnord_before ),
            	],
            TC_smnord_after: [
            		() => params.TC_smnord_after && Validation.isInt(params.TC_smnord_after ),
            	],
          };
        
        const validateResult = Validation.validateAllRules(validateRules);

        if (Object.keys(validateResult).length > 0) {
            setValidateResults({ ...validateResult });
            window.scrollTo(0, 0);
            return false;
          }
        setValidateResults({});
        return true;
    };

    const handleReset = () => {
        setParams({});
        setValidateResults({});
        let dataSb = {
            content: {},
          };
        updateSettingCustomTimerctrl({
            eventShortName: shortName,
            data: dataSb,
        });
     };

    const handleCancel = () => {
        setParams(customTimerctrl);
     };

    const handleSubmit = () => {
        if (validate()) {
            setIsOpenConfirmSuccess({ open: true, content: '適用して宜しいですか。', type: 'submit' });
        }
     };

    const handleSuccessDialog = (type) => {
        setIsOpenConfirmSuccess({ open: false, content: '', type: '' });
        let sbData = {
            content: {
                TC_exhlist_before: params.TC_exhlist_before || '',
                TC_exhprod_after : params.TC_exhprod_after  || '',
                TC_smn_before    : params.TC_smn_before     || '',
                TC_smn_after     : params.TC_smn_after      || '',
                TC_live_before   : params.TC_live_before    || '',
                TC_live_after    : params.TC_live_after     || '',
                TC_smnord_before : params.TC_smnord_before  || '',
                TC_smnord_after  : params.TC_smnord_after   || '',

            }
          };
          
        if (type === 'submit') {
            updateSettingCustomTimerctrl({
                eventShortName: shortName,
                data: sbData,
              });
        } else if (type === 'reset') {
            handleReset();
        } else if (type === 'cancel') {
            handleCancel();
          }
     };

    return (
        <>
            <GridContainer className={classes.container}>
                <WrapperContainer>
                    <GridContainer className={classes.customSite}>
                        <GridItem>
                            <Typography bold>出展企業一覧　公開日の日数設定</Typography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer>
                        <GridItem>
                            <CleanableInput
                                rows={1}
                                defaultValue={params.TC_exhlist_before}
                                onChange={(value) => handleChange("TC_exhlist_before", value.trim())}
                                  />日前より表示<br />（展示会開始日までの日数。前日から表示なら1を入力。）
                        </GridItem>
                    </GridContainer>


                    <GridContainer className={classes.customSiteExhibitor}>
                        <GridItem>
                            <Typography bold>出展製品詳細終了　展示会終了日からの表示期間日数設定</Typography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer>
                        <GridItem>
                            <CleanableInput
                                rows={1}
                                isMultiline
                                defaultValue={params.TC_exhprod_after}
                                onChange={(value) => handleChange('TC_exhprod_after', value.trim())}
                                  />日後まで表示<br />（展示会終了日からの日数。翌日なら1を入力。）
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.customSiteExhibitor}>
                        <GridItem>
                            <Typography bold>セミナーの一覧　公開日の日数設定</Typography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer>
                        <GridItem>
                            <CleanableInput
                                rows={1}
                                isMultiline
                                defaultValue={params.TC_smn_before}
                                onChange={(value) => handleChange('TC_smn_before', value.trim())}
                                   />日前より表示<br />（展示会開始日までの日数。前日から表示なら1を入力。）
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.customSiteExhibitor}>
                        <GridItem>
                            <Typography bold>セミナーの一覧の終了　展示会終了日からの表示期間日数設定</Typography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer>
                        <GridItem>
                            <CleanableInput
                                rows={1}
                                isMultiline
                                defaultValue={params.TC_smn_after}
                                onChange={(value) => handleChange('TC_smn_after', value.trim())}
                                  />日後まで表示<br />（展示会終了日からの日数。翌日なら1を入力。）
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.customSiteExhibitor}>
                        <GridItem>
                            <Typography bold>ライブ配信申込み開始　公開日の日数設定</Typography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer>
                        <GridItem>
                            <CleanableInput
                                rows={1}
                                isMultiline
                                defaultValue={params.TC_live_before}
                                onChange={(value) => handleChange('TC_live_before', value.trim())}
                                   />日前より表示<br />（展示会開始日までの日数。前日から表示なら1を入力。）
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.customSiteExhibitor}>
                        <GridItem>
                            <Typography bold>ライブ配信申込み終了　展示会終了日からの表示期間日数設定</Typography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer>
                        <GridItem>
                            <CleanableInput
                                rows={1}
                                isMultiline
                                defaultValue={params.TC_live_after}
                                onChange={(value) => handleChange('TC_live_after', value.trim())}
                                  />日後まで表示<br />（展示会終了日からの日数。翌日なら1を入力。）
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.customSiteExhibitor}>
                        <GridItem>
                            <Typography bold>セミナー申込み開始　公開日の日数設定</Typography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer>
                        <GridItem>
                            <CleanableInput
                                rows={1}
                                isMultiline
                                defaultValue={params.TC_smnord_before}
                                onChange={(value) => handleChange('TC_smnord_before', value.trim())}
                                   />日前より表示<br />（展示会開始日までの日数。前日から表示なら1を入力。）
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.customSiteExhibitor}>
                        <GridItem>
                            <Typography bold>セミナー申込み終了　展示会終了日からの表示期間日数設定</Typography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer>
                        <GridItem>
                            <CleanableInput
                                rows={1}
                                isMultiline
                                defaultValue={params.TC_smnord_after}
                                onChange={(value) => handleChange('TC_smnord_after', value.trim())}
                            />
                        </GridItem>
                    </GridContainer>




                    <GridContainer className={classes.customFooter}>
                        <GridItem className={classes.customFooterButton}>
                            <Button
                                color="info"
                                round
                                gradient
                                size="md"
                                onClick={() => handleSubmit()}
                                className={classes.customButton}
                           			 >
                                <b>適用する</b>
                            </Button>
                            <Button
                                color="info"
                                round
                                gradient
                                size="md"
                                onClick={() => setIsOpenConfirmSuccess({ open: true, content: 'リセットして宜しいですか。', type: 'reset' })}
                                className={classes.customButtonReset}
                           			 >
                                <b>リセット</b>
                            </Button>
                            <Button
                                color="info"
                                round
                                gradient
                                size="md"
                                onClick={() => setIsOpenConfirmSuccess({ open: true, content: '入力した情報をキャンセルして宜しいですか。', type: 'cancel' })}
                                className={classes.customButton}
                            		>
                                <b>キャンセル</b>
                            </Button>
                        </GridItem>
                    </GridContainer>
                </WrapperContainer>
            </GridContainer>
            <Snackbar
                open={isOpenSnackbar.isOpen}
                onClose={() => setIsOpenSnackbar({ isOpen: false, message: '' })}
                message={isOpenSnackbar.message}
                severity="success"
                autoHideDuration={3000}
           	 	/>
            <AlertDialog
                title="確認ダイアログ"
                handleClose={() => setIsOpenConfirmSuccess({ open: false, content: '', type: '' })}
                handleOpen={isOpenConfirmSuccess.open}
                handleSubmit={() => handleSuccessDialog(isOpenConfirmSuccess.type)}
                contents={isOpenConfirmSuccess.content}
            	/>
        </>
    );
};

SettingCustomTimerCTRL.defaultProps = {
    getSettingCustomTimerctrl: () => {},
    clearGetSettingCustomTimerctrl: () => {},
    updateSettingCustomTimerctrl: () => {},
    clearUpdateSettingCustomTimerctrl: () => {},
    customTimerctrl: {},
    updateCustomTimerctrl: {},
    updateStatusTimerctrl: false,
    eventInfo: {},
};

SettingCustomTimerCTRL.propTypes = {
    getSettingCustomTimerctrl: PropTypes.func,
    clearGetSettingCustomTimerctrl: PropTypes.func,
    updateSettingCustomTimerctrl: PropTypes.func,
    clearUpdateSettingCustomTimerctrl: PropTypes.func,
    customTimerctrl: PropTypes.oneOfType([() => null, PropTypes.object]),
    updateCustomTimerctrl: PropTypes.oneOfType([() => null, PropTypes.object]),
    updateStatusTimerctrl: PropTypes.bool,
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
};

export default SettingCustomTimerCTRL;
